import { ColDef, GridOptions } from "ag-grid-community";

import { getCommonGridOptions } from "./common_grid_options";
import { RoleTypes } from "./role_assignment_constants";
import { MutationLike } from "@src/types";

const columnDefs: ColDef[] = [
  {
    headerName: "Basic Role",
    field: "basicRoleName",
    colId: "basicRole", // needed for getFilterInstance in role_assignment_filter
    filter: "agSetColumnFilter",
  },
  {
    headerName: "Area",
    field: "area.areaName",
    filter: "agSetColumnFilter",
  },
];

/**
 * sets the grid options for the BasicRoleManagement.
 * combining basic role specific grid options with common ones
 *
 * @param updateRoleRtkFunction function to reach the update endpoint
 * @param deleteRoleRtkFunction function to reach the delete endpoint
 * @returns the grid options
 */
export function createGridOptions(
  updateRoleRtkFunction: MutationLike,
  deleteRoleRtkFunction: MutationLike
): GridOptions {
  return getCommonGridOptions(
    RoleTypes.BASIC_ROLE,
    columnDefs,
    updateRoleRtkFunction,
    deleteRoleRtkFunction
  );
}
